import { Component, Input } from '@angular/core';
import { Rol, UitnodigingStatus } from 'parkour-web-app-dto';
import {
  IParkourAvatarBadgeImageProps,
  ParkourAvatarBadgeComponent,
  ParkourIconComponent,
} from '@parkour/ui';
import { NgClass } from '@angular/common';
import { RolLabelPipe } from '../../../shared/pipes/rol-label.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'parkour-teammember-uitnodiging-item',
  templateUrl: './teammember-uitnodiging-item.component.html',
  imports: [
    NgClass,
    ParkourAvatarBadgeComponent,
    RolLabelPipe,
    ParkourIconComponent,
    TranslateModule,
  ],
})
export class TeammemberUitnodigingItemComponent {
  @Input() public classes?: string;
  @Input({ required: true }) public image!: IParkourAvatarBadgeImageProps;
  @Input({ required: true }) public naam!: string;
  @Input({ required: true }) public status!: UitnodigingStatus;
  @Input() public rol!: Rol;
  @Input() public disabled = false;
  @Input() public professioneel = false;
}
